// extracted by css-extract-rspack-plugin
export default {"bui-Tooltip":"eWlIjEt2sVoNRq4n","bui-TooltipContent":"b7XPtf412PUr83RB","bui-TooltipArrow":"xvtsHOqUiVI0euqI"};